<template>
  <van-row justify="center" class="page-wrapper">
    <template>
      <van-col span="24" class="itserve-center flex-display-fix">
        <account
          ref="accountComponent"
          :account="account"
          :show-balance="true"
          :update-amount="updateAmount"
          class="round-shadow-btn p-25 pb-25 container_width mt-15"
          @update:services="updateServices"
        />
      </van-col>
      <van-col
        span="24"
        class="itserve-center flex-display-fix container_width mt-15"
      >
        <!--        <info-message class="apply-loader flex-display-fix write-ticket-message"-->
        <!--        >{{ $t("pay.inDevelopment") }}-->
        <!--        </info-message>-->

        <div class="payment-details" v-if="services.totalAmount > 0">
          <div class="services-list">
            <div
              v-for="(service, index) in services.services"
              :key="index"
              class="service-row"
            >
              <span class="service-name">
                <span
                  class="service-icon"
                  v-if="service.name.includes('Нафтогаз')"
                  >⛽</span
                >
                <span class="service-icon" v-else>🔧</span>
                {{ service.name }}
              </span>
              <span class="service-amount"
                >{{ parseFloat(service.amount).toFixed(2) }}
                {{ $t("components.accounts.currency") }}</span
              >
            </div>
          </div>
          <div class="total-amount">
            <span>До сплати:</span>
            <strong
              >{{ parseFloat(services.totalAmount).toFixed(2) }}
              {{ $t("components.accounts.currency") }}</strong
            >
          </div>
        </div>
        <!--        <template v-if="!getPhone && stripePayment === 1" >-->
        <template v-if="!getPhone">
          <div class="itserve-center">
            <itserve-button
              type="primary"
              :value="$t('pay.pay')"
              class="mt-15 apply-loader"
              @click="showPopup = true"
            />
          </div>
          <add-phone v-if="showPopup"></add-phone>
        </template>
        <!--        <template v-else-if="!getEmail && stripePayment === 0" >-->
        <!--          <div class="itserve-center">-->
        <!--            <itserve-button-->
        <!--              type="primary"-->
        <!--              :value="$t('pay.pay')"-->
        <!--              class="mt-15 apply-loader"-->
        <!--              @click="showPopup = true;"-->
        <!--            />-->
        <!--          </div>-->
        <!--          <add-email v-if="showPopup"></add-email>-->
        <!--        </template>-->
        <template v-else>
          <div class="itserve-center">
            <div
              v-if="services.totalAmount <= 0"
              class="error-message mb-10 full-width"
            >
              {{ $t("pay.selectAtLeastOneService") }}
            </div>
            <itserve-button
              type="primary"
              :value="$t('pay.pay')"
              class="mt-15 apply-loader"
              :disabled="services.totalAmount <= 0"
              @click="runPayment"
            />
          </div>
        </template>
        <!--                <itserve-route-->
        <!--                  type="primary"-->
        <!--                  :buttonName="$t('pay.addCard')"-->
        <!--                  class="mt-15"-->
        <!--                  route-name="AddCard"-->
        <!--                />-->
        <itserve-route
          route-name="Prices"
          :buttonName="$t('buttons.prices')"
          type="wide"
          class="nav-btn mt-15"
          :icon="true"
          icon-color="#4285F4"
        >
          <prices-icon />
        </itserve-route>
        <div class="place-content-center">
          <info-message class="pay-info-message apply-loader">
            {{ $t("pay.debtNotification") }}
          </info-message>
        </div>

        <!--                <div class="itserve-center">-->
        <!--                  <itserve-button-->
        <!--                    type="primary"-->
        <!--                    :value="$t('pay.receipt')"-->
        <!--                    class="apply-loader"-->
        <!--                  ></itserve-button>-->
        <!--                </div>-->
      </van-col>
    </template>
  </van-row>
</template>
<script>
// import ItserveInput from "@/components/forms/ItserveInput";
import ItserveButton from "@/components/forms/ItserveButton";
import InfoMessage from "@/components/content/InfoMessage";
import "vue-awesome/icons/money-bill-wave";
import "vue-awesome/icons/plus";
import "vue-awesome/icons/file-invoice-dollar";
import Account from "../../../components/helpers/Account";
import ItserveRoute from "@/components/content/ItserveRoute";
import PricesIcon from "@/components/icons/prices-icon";
import addPhone from "../../../components/popup/addPhone";
// import addEmail from "../../../components/popup/addEmail";
// import Badge from "vant/lib/badge/index";
export default {
  name: "Pay",
  components: {
    PricesIcon,
    ItserveRoute,
    Account,
    InfoMessage,
    ItserveButton,
    // ItserveInput,
    addPhone,
    // addEmail,
    // VanBadge: Badge,
  },

  // Используем подход как в Нафтогазе - без сброса значений
  data() {
    return {
      showPopup: false,
      showError: false,
      services: {
        services: [],
        totalAmount: 0,
      },
      // Отдельные суммы для разных типов оплаты
      naftogazAmount: 0,
      distributionAmount: 0,
      paymentUrl: "",
      stripeSubscriptionData: {
        loading: false,
        mode: "subscription",
        email: this.$store.state.Settings.settings.email,
        user_id: this.$store.state.Auth.user_id,
        app_id: this.$store.state.Auth.nativeData.id,
      },
    };
  },
  computed: {
    cards() {
      return this.$store.state.Payment.cards;
    },
    amount: {
      get() {
        return this.$store.state.Payment.paymentData.amount || 0;
      },
      set(amount) {
        this.$store.commit("Payment/UPDATE_AMOUNT", amount);
      },
    },
    account() {
      return this.$store.state.Auth.account;
    },
    getPhone() {
      return this.$store.state.Auth.phoneNumber;
    },
    stripePayment() {
      return this.$store.state.Auth.stripe_payment;
    },
    stripeSub() {
      return this.$store.state.Auth.status_sub;
    },
    getEmail() {
      return this.$store.state.Settings.checkEmail;
    },
  },
  watch: {
    paymentUrl(paymentUrl) {
      window.location.href = paymentUrl;
    },
  },
  created() {
    this.preparePaymentPage();
  },
  methods: {
    async preparePaymentPage() {
      // Загружаем данные аккаунта без сброса значений
      await this.$store.dispatch(
        "Auth/getUserAccount",
        this.$route.params.account
      );
      await this.$store.dispatch("Payment/getCardsList");

      this.$store.commit("Payment/SET_USER_LS", this.$route.params.account);

      // Задолженность по распределению газа уже загружена в компоненте Account.vue
    },
    showNotification() {
      if (this.cards.length) {
        this.showDialog = true;
      } else {
        this.runPayment();
      }
    },
    async updateServices(services) {
      // Обновляем локальные значения без сброса предыдущих
      this.services = services;
      this.amount = services.totalAmount;

      // Разделяем суммы по типам оплаты
      this.naftogazAmount = 0;
      this.distributionAmount = 0;

      // Перебираем все услуги и разделяем суммы
      services.services.forEach((service) => {
        if (service.name.includes("Нафтогаз")) {
          this.naftogazAmount = parseFloat(service.amount);
        } else if (service.name.includes("Газорозподільні")) {
          this.distributionAmount = parseFloat(service.amount);
        }
      });

      console.log("Суммы по типам оплаты:", {
        naftogazAmount: this.naftogazAmount,
        distributionAmount: this.distributionAmount,
        totalAmount: this.amount,
      });
    },
    updateAmount: function (amount) {
      console.log("updateAmount called with amount:", amount);
      this.amount = amount;
    },
    async runPayment() {
      // Перевіряємо, чи вибрано хоча б одну послугу
      if (this.services.totalAmount <= 0) {
        // Не робимо нічого, оскільки кнопка вже буде вимкнена
        // а повідомлення про помилку вже відображається в шаблоні
        return;
      }

      try {
        // Проверяем, есть ли услуги для оплаты
        const hasNaftogazPayment = this.naftogazAmount > 0;
        const hasDistributionPayment = this.distributionAmount > 0;

        console.log("Оплата услуг:", {
          hasNaftogazPayment,
          hasDistributionPayment,
          naftogazAmount: this.naftogazAmount,
          distributionAmount: this.distributionAmount,
        });

        // Если нет выбранных услуг, выходим
        if (!hasNaftogazPayment && !hasDistributionPayment) {
          this.$toast.error("Виберіть хоча б одну послугу для оплати");
          return;
        }

        // Проверяем данные для оплаты распределения
        if (hasDistributionPayment) {
          // Получаем данные лицевого счета
          const ls = this.account.lsDistrib;

          if (!ls) {
            this.$toast.error(
              "Відсутній особовий рахунок для оплати розподілу газу"
            );
            return;
          }

          // Проверяем, является ли счет распределения недействительным
          if (this.$refs.accountComponent.invalidDistributionAccount) {
            this.$toast.error(
              "Невірний рахунок розподілу газу. Будь ласка, введіть правильний рахунок."
            );
            // Показываем форму добавления счета распределения
            this.$refs.accountComponent.showAddDistributionAccountModal = true;
            return;
          }
        }

        // Определяем тип платежа и добавляем соответствующие параметры
        // Добавляем уникальный таймстемп, чтобы браузер не кэшировал страницу
        const params = {
          account: this.$route.params.account,
          city: this.$route.params.city,
          _: new Date().getTime(), // Уникальный параметр для предотвращения кэширования
        };

        if (hasNaftogazPayment && hasDistributionPayment) {
          // Комбинированный платеж
          params.naftogazAmount = this.naftogazAmount;
          params.distributionAmount = this.distributionAmount;
          params.distributionLs = this.account.lsDistrib;
          params.city = this.account.city;
          params.paymentType = "combined"; // Оба типа платежа
        } else if (hasNaftogazPayment) {
          // Только Нафтогаз
          params.naftogazAmount = this.naftogazAmount;
          params.paymentType = "naftogaz";
        } else if (hasDistributionPayment) {
          // Только распределение
          params.distributionAmount = this.distributionAmount;
          params.distributionLs = this.account.lsDistrib;
          params.city = this.account.city;
          params.paymentType = "distribution";
        }

        console.log("НОВЫЕ параметры оплаты для маршрута:", params);

        await this.$router.push({
          name: "EasyPayPayment",
          params: params,
        });
      } catch (error) {
        console.error("Ошибка при обработке оплаты:", error);
        this.$toast.error("Произошла ошибка при обработке оплаты");
      }
    },
  },
};
</script>
<style scoped>
/* Error message styles */
.error-message {
  color: #f44336;
  font-size: 14px;
  text-align: center;
  padding: 10px 15px;
  border-radius: 8px;
  background-color: rgba(244, 67, 54, 0.1);
}

.full-width {
  width: 100%;
  max-width: 337px;
  box-sizing: border-box;
  margin: 0 auto;
}

/* Dark theme styles */
.app-theme-dark .error-message {
  background-color: rgba(244, 67, 54, 0.2);
  color: #ff8a80;
}

/* Light theme styles */
.payment-details {
  width: 100%;
  margin: 16px 0;
  padding: 0;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid #e8e8e8;
  transition: all 0.3s ease;
}

.services-list {
  margin: 0;
  padding: 12px 0;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

.service-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  transition: background-color 0.2s ease;
}

.service-row:not(:last-child) {
  border-bottom: 1px solid #f0f0f0;
}

.service-row:last-child {
  border-bottom: none;
}

.service-row:hover {
  background-color: #f8f8f8;
}

.service-name {
  color: #424242;
  font-size: 15px;
  display: flex;
  align-items: center;
}

.service-icon {
  margin-right: 8px;
  opacity: 0.8;
  font-size: 16px;
}

.service-amount {
  font-weight: 600;
  color: #1a1a1a;
  background: #f0f9f0;
  padding: 4px 10px;
  border-radius: 12px;
  min-width: 70px;
  text-align: center;
  transition: all 0.2s ease;
}

.total-amount {
  margin: 0;
  padding: 16px;
  background: linear-gradient(135deg, #f8fff8 0%, #f0f9f0 100%);
  text-align: right;
  font-size: 16px;
  color: #1a8a4a;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px dashed #d0e8d0;
  transition: all 0.3s ease;
}

.total-amount:before {
  content: "→";
  color: #1aad62;
  margin-right: 8px;
  font-size: 18px;
  transition: color 0.3s ease;
}

.total-amount strong {
  color: #1a8a4a;
  font-size: 18px;
  font-weight: 600;
  transition: color 0.3s ease;
}

/* Dark theme overrides */
.app-theme-dark .payment-details {
  background-color: #2d2d2d;
  border-color: #3d3d3d;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
}

.app-theme-dark .services-list {
  background-color: #0e121b;
  border-bottom-color: #609065;
}

.app-theme-dark .service-row {
  border-bottom-color: #444;
}

.app-theme-dark .service-row:hover {
  background-color: #3a3a3a;
}

.app-theme-dark .service-name {
  color: #e0e0e0;
}

.app-theme-dark .service-amount {
  background-color: #2d3d2d;
  color: #8bc34a;
}

.app-theme-dark .total-amount {
  background: linear-gradient(135deg, #1a2e1a 0%, #1a3d1a 100%);
  color: #8bc34a;
  border-top-color: #2d4d2d;
}

.app-theme-dark .total-amount:before {
  color: #4caf50;
}

.app-theme-dark .total-amount strong {
  color: #8bc34a;
}
</style>

<style>
.pay-info-message .info-content {
  text-align: center !important;
}
</style>
<style scoped>
@import "../../../../node_modules/vant/lib/cell/index.css";
.button-badge {
  margin-bottom: 15px;
  max-width: 337px;
  display: inline-block;
  width: 100%;
  text-align: right;
  position: relative;
}
.button-badge .van-badge {
  padding: 5px 10px;
  font-size: 14px;
  color: #0b0b0b;
  border-radius: 4px;
}
.badge-triangle {
  width: 10px;
  height: 10px;
  background-color: #f6f6f6;
  position: absolute;
  right: 40px;
  transform: rotate(45deg);
  top: 23px;
}
</style>
